import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {Reel} from "../../reels/Reel";
import {SimpleReelModelSymbolData} from "../../../core/reel/simplereel/SimpleReelModel";
import {XSplitSymbol} from "../../reels/symbols/XSplitSymbol";
import {XNudgeSymbol} from "../../reels/symbols/XNudgeSymbol";
import {BasicSymbol, SymbolStates} from "../../reels/symbols/BasicSymbol";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {NormalSymbol} from "../../reels/symbols/NormalSymbol";
import {XWaySymbol} from "../../reels/symbols/XWaySymbol";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class XSplitPresentation implements SimplePresentation {

    name: string = "XSplitPresentation";
    private _xSpos: number[][] = [[], [], [], [], [], []];


    shouldRun(): boolean {
        return !XwaysHoarder2.model.checkRespinScenario;
    }

    start(controller: SimplePresentationRunnerController): void {
        controller.setSkipCallback();
        const mainTL: gsap.core.Timeline = gsap.timeline({
            onStart: () => {
                if (XwaysHoarder2.model.isDefinitelyADeadSpin)
                    mainTL.timeScale(2);
            },
            onComplete: () => {
                mainTL.timeScale(1);
                controller.setSkipCallback();
                controller.finish();
            }
        });
        this._xSpos = [[], [], [], [], [], []];
        let playPresentation: boolean = false;


        XwaysHoarder2.reelView.reels.forEach((reel: Reel, reelId: number) => {//making data
            [0, 1, 2].forEach((symID) => {
                const symData: SimpleReelModelSymbolData = reel.model.getVisibleSymbolAt(symID);
                if (symData.name === "XS" || symData.name === "XN") {
                    playPresentation = true;
                    // console.log("reel: ", reelId, " symId: ", symID);
                    this._xSpos[reelId].push(symID);
                }
            });
        });

        if (playPresentation) {
            let count: number = 0;
            let splitSoundPlayedONReel: boolean [] = [false, false, false, false, false];
            let xnToWildSoundPlayedOnReel: boolean [] = [false, false, false, false, false];
            const reels = XwaysHoarder2.model.data.reels;

            this._xSpos.forEach((posPerReel: number[], reelID: number) => {
                const oneReelTl: gsap.core.Timeline = gsap.timeline();

                posPerReel.forEach((symID: number) => {
                    const oneSplitTl: gsap.core.Timeline = gsap.timeline();
                    const sym: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelID].model.getVisibleSymbolAt(symID);

                    oneSplitTl.addLabel("start", 0); // #417

                    oneSplitTl.add((<XSplitSymbol | XNudgeSymbol>sym.positionable).getStateAnimation(SymbolStates.START_SPLIT), "start");

                    if(!xnToWildSoundPlayedOnReel[reelID]  && reels[reelID].indexOf("XN") < 0) {
                        xnToWildSoundPlayedOnReel[reelID] = true;
                        oneSplitTl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XSPLIT_TO_WILD);
                        }, (XwaysHoarder2.model.isDefinitelyADeadSpin)? "-=" + 0.4 + 0.211 : "-=0.4"); // -0.211
                    }


                    const symSplitTl: gsap.core.Timeline = gsap.timeline({
                        delay: 0.3
                    });
                    let rowTraverseCount: number = 0;
                    for (let rowNo: number = reelID - 1; rowNo > -1; rowNo--) {
                        const symToSplit: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[rowNo].model.getVisibleSymbolAt(symID);
                        if (symToSplit.name === "D") {
                            if (symID === 1) {
                                const upperSymId: number = JSON.parse(JSON.stringify(symID)) - 1;
                                const upperSym: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[rowNo].model.getVisibleSymbolAt(upperSymId);
                                if (upperSym.name === "XW") {
                                    if ((<XWaySymbol>upperSym.positionable).symbolHeight >= 2) {
                                        symSplitTl.add((<XWaySymbol>upperSym.positionable).getStateAnimation(SymbolStates.SPLIT), (0.1 * rowTraverseCount));
                                    }
                                }

                            } else if (symID == 2) {
                                const upperSymId: number = JSON.parse(JSON.stringify(symID)) - 1;
                                const upperSym: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[rowNo].model.getVisibleSymbolAt(upperSymId);
                                if (upperSym.name === "XW") {
                                    if ((<XWaySymbol>upperSym.positionable).symbolHeight === 2) {
                                        symSplitTl.add((<XWaySymbol>upperSym.positionable).getStateAnimation(SymbolStates.SPLIT), (0.1 * rowTraverseCount));
                                    }

                                } else {
                                    const topSymid: number = 0;
                                    const topSym: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[rowNo].model.getVisibleSymbolAt(topSymid);
                                    if (topSym.name === "XW") {
                                        if ((<XWaySymbol>topSym.positionable).symbolHeight === 3) {
                                            symSplitTl.add((<XWaySymbol>topSym.positionable).getStateAnimation(SymbolStates.SPLIT), (0.1 * rowTraverseCount));
                                        }
                                    }
                                }
                            }
                        } else {
                            symSplitTl.add((<XSplitSymbol | XNudgeSymbol | XWaySymbol | NormalSymbol>symToSplit.positionable).getStateAnimation(SymbolStates.SPLIT), (0.1 * rowTraverseCount));
                        }

                        rowTraverseCount++;
                    }
                    oneSplitTl.add([
                        symSplitTl,
                        this.addArrowAnimation(reelID, symID).timeScale(2)
                    ], "start"); // #417
                   if(!splitSoundPlayedONReel[reelID]) {
                        oneSplitTl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XSPLIT_SPLIT);
                        }, "start");
                       splitSoundPlayedONReel[reelID] = true;
                    }

                   if(sym.name === "XN" && !xnToWildSoundPlayedOnReel[reelID]) {
                       oneSplitTl.add(() => {
                           XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XSPLIT_NUDGE_TO_WILD);
                       }, (XwaysHoarder2.model.isDefinitelyADeadSpin)? (20 / 30) - 0.212  : 20 / 30); // -0.212
                       xnToWildSoundPlayedOnReel[reelID] = true;
                   }

                    oneReelTl.add(oneSplitTl, 0);
                });

                // #417
                if (posPerReel.length) {
                    mainTL.add(oneReelTl, (count * 0.8));
                    count++;
                }
            });
        }

        if (playPresentation) {//converting all XN symbols to XS in wild state
            mainTL.add(() => {
                this._xSpos.forEach((posPerReel: number[], reelID: number) => {
                    posPerReel.forEach((symID: number) => {
                        const sym: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelID].model.getVisibleSymbolAt(symID);
                        if (sym.name === "XN") {
                            XwaysHoarder2.reelView.reels[reelID].replaceSymOnReel(symID, "XS", true, SymbolStates.REMOVED, "_revealed2", (<BasicSymbol>sym.positionable).symSize);
                           /* const xsSym:XSplitSymbol=<XSplitSymbol>XwaysHoarder2.reelView.reels[reelID].model.getVisibleSymbolAt(symID).positionable;
                            xsSym.getStateAnimation(SymbolStates.REMOVED);*/
                        }
                    });
                });
            }, mainTL.totalDuration());
        }

        controller.setSkipCallback(() => {
            this.onXsplitSkip(mainTL)
        });
    }

    private onXsplitSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }

    private addArrowAnimation(reelID: number, rowID: number): gsap.core.Timeline {
        const arrowTl: gsap.core.Timeline = gsap.timeline();
        const arrow: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.XSPLIT_ARROW));
        arrow.name = "arrowSPine";
        arrow.position.set(-40, rowID * XwaysHoarder2Statics.symbolHeight + XwaysHoarder2Statics.symbolHeight * 0.5);
        arrowTl.add(() => {
            XwaysHoarder2.reelView.reels[reelID].layers.lockOverlay.addChild(arrow);
        }, 0.005);
        arrowTl.add(SpineGSAPWrapper.createTimelineForAnimation(arrow, 0, "splitArrow", false));
        arrowTl.to(arrow.position, {x: -reelID * XwaysHoarder2Statics.symbolWidth + 75, duration: 0.2 * (reelID)}, ">");
        arrowTl.add(() => {
            XwaysHoarder2.reelView.reels[reelID].layers.lockOverlay.removeChild(arrow);
        });
        return arrowTl;
    }
}